import { AdminBarberRepository } from "../../Repository";

export async function changeBusinessAddress(
  businessAddress: string,
  repository: AdminBarberRepository
): Promise<boolean> {
  return repository.setBarberShopAddress(businessAddress);
}
